import React, {Component} from 'react';
import {Popup, Icon, Progress, Loader} from 'semantic-ui-react';
import './progressBar.scss';

class ProgressBar extends Component {
  renderLabel() {
    const {label, hideLabel, partialQuantity, totalQuantity} = this.props;
    const processedAmount = partialQuantity || 0;
    const totalAmount = totalQuantity || 0;
    const percent = parseInt((processedAmount / totalAmount) * 100, 10) || 0;

    if (!hideLabel) {
      return (
        <label>
          Progreso: {percent}% | {label}: {processedAmount} de {totalAmount}
        </label>
      );
    }
  }

  renderPopUp() {
    const {hideIcon, lowPercent, mediumPercent} = this.props;
    const lowPercentPoint = lowPercent || 33;
    const mediumPercentPoint = mediumPercent || 66;
    const description = !lowPercent && !mediumPercent ?
      'Cada 33% la barra de progreso cambiará de color:' : 'Criterios de progreso:';

    if (!hideIcon) {
      return (
        <Popup
          trigger={<Icon link name='info circle' color='blue' size='large' />}
          on='click'
          position='bottom left'
          inverted
        >
          <div>
            <p>{description}</p>
            <ul>
              <li>
                <strong>Rojo:</strong>{` 0% - ${lowPercentPoint}%`}
              </li>
              <li>
                <strong>Amarillo:</strong>{` ${lowPercentPoint + 1}% - ${mediumPercentPoint}%`}
              </li>
              <li>
                <strong>Verde:</strong>{` ${mediumPercentPoint + 1}% - 100%`}
              </li>
            </ul>
          </div>
        </Popup>
      );
    }
  }

  renderProgressBar() {
    const {loading, partialQuantity, totalQuantity, hideIcon, amountColors} = this.props;

    if (loading) {
      return (
        <div className='progress-bar'>
          <Loader active inline='centered' />
        </div>
      );
    }

    const processedAmount = partialQuantity || 0;
    const totalAmount = totalQuantity || 0;
    const percent = parseInt((processedAmount / totalAmount) * 100, 10) || 0;

    const color = !amountColors ? this.getProgressBarColor(percent) : this.getProgressBarColorInverted(percent);

    return (
      <div className='progress-bar'>
        <div className='label-info'>
          {this.renderLabel()}
          {this.renderPopUp()}
        </div>
        <Progress
          percent={percent === 0 ? 100 : percent}
          color={color}
          size={!hideIcon ? 'tiny' : 'small'}
          inverted={percent === 0}
        />
      </div>
    );
  }

  getProgressBarColor(percent) {
    const {lowPercent, mediumPercent} = this.props;
    
    if (!percent) {
      return 'grey';
    } else if (percent <= (lowPercent || 33)) {
      return 'red';
    } else if (percent <= (mediumPercent || 66)) {
      return 'yellow';
    }
    return 'green';
  }

  getProgressBarColorInverted(percent) {
    const {lowPercent, mediumPercent} = this.props;

    if (!percent) {
      return 'grey';
    } else if (percent <= (lowPercent || 33)) {
      return 'green';
    } else if (percent <= (mediumPercent || 66)) {
      return 'yellow';
    }
    return 'red';
  }

  render() {
    return this.renderProgressBar();
  }
}

export default ProgressBar;
